import RiskFlagAlert from "../../common/RiskFlagAlert";
import {
  getSerialFraudIndicatorState,
  SerialFraudIndicatorState,
} from "../../../utils/serialFraudDashboard";

type SerialFraudRow = {
  id?: string | number | null;
  hasFraudRisk?: unknown;
};

export const renderSerialFraudIndicator = (
  record: SerialFraudRow | null | undefined,
  fraudFlagsByApplicationId: Record<string, SerialFraudIndicatorState>
) => {
  const hasFraudRisk = getSerialFraudIndicatorState(record, fraudFlagsByApplicationId);

  return hasFraudRisk === true || hasFraudRisk === null ? (
    <RiskFlagAlert isFraudRiskMatch={hasFraudRisk} displayVariant="icon" />
  ) : null;
};
